import { render, staticRenderFns } from "./Channel.vue?vue&type=template&id=c8580a5c"
import script from "./Channel.vue?vue&type=script&lang=js"
export * from "./Channel.vue?vue&type=script&lang=js"
import style0 from "./Channel.vue?vue&type=style&index=0&id=c8580a5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports